module.exports = __webpack_public_path__ + "img/22.a2f6ad27.jpg";